import React from 'react';
import PropTypes from 'prop-types';
import { AspectRatioContainer } from 'site-modules/shared/components/aspect-ratio-container/aspect-ratio-container';
import classnames from 'classnames';

export function SeoEmbeddedYoutube({ containerClassName = null, creativeId = null, videoAspectRatio = '16:9' }) {
  return (
    !!creativeId &&
    !!videoAspectRatio && (
      <AspectRatioContainer
        aspectRatio={videoAspectRatio}
        className={classnames('embedded-youtube-container', containerClassName)}
      />
    )
  );
}

SeoEmbeddedYoutube.propTypes = {
  containerClassName: PropTypes.string,
  creativeId: PropTypes.string,
  videoAspectRatio: PropTypes.string,
};
